import request from '@/utils/request'

// 获取部门结构树
export function getOrganizationTree(data) {
  return request({
    url: '/sys/team/organizationTree',
    method: 'post',
    data,
    load: true
    }
  )
}
// 获取下拉部门列表
export function getDepartmentList(data) {
  return request({
    url: '/sys/team/sportDeptList',
    method: 'post',
    data,
    load: true
    }
  )
}
// 修改部门排序
export function updateTeamSort(data) {
  return request({
    url: '/sys/team/organizationListUpdate',
    method: 'post',
    data,
    load: true,
    debounce: true,
    }
  )
}

// 修改运动组排序
export function sortGroup(data) {
  return request({
      url: '/sys/team/groupListUpdate',
      method: 'post',
      data,
      load: true,
    debounce: true,
    }
  )
}

// 修改运动队排序
export function sortTeam(data) {
  return request({
      url: '/sys/team/teamListUpdate',
      method: 'post',
      data,
      load: true,
    debounce: true,
    }
  )
}

// 获取运动队下拉列表
export function getTeamList(data) {
  return request({
    url: '/sys/team/sportTeamList',
    method: 'post',
    data,
    load: true
    }
  )
}

// 获取负责人下拉列表
export function getMemberList() {
  return request({
    url: '/api/joinUser/getUserList',
    method: ''
  })
}

// 新增运动队
export function addTeam(data) {
  return request({
    url: '/sys/team/add',
    method: 'post',
    data,
    load: true,
    debounce: true,
    }
  )
}

// 删除运动队
export function deleteTeam(data) {
  return request({
    url: '/sys/team/del',
    method: 'post',
    data,
    load: true,
    debounce: true,
    }
  )
}

// 修改运动队
export function updateTeam(data) {
  return request({
    url: '/sys/team/edit',
    method: 'post',
    data,
    load: true,
    debounce: true,
    }
  )
}

// 获取运动队
export function getTeam(params) {
  return request({
    url: '/sys/team/getInfo',
    method: 'get',
    params,
    load: true
    }
  )
}

// 修改运动队状态
export function updateTeamStatus(data) {
  return request({
    url: '/sys/team/updateByStatus',
    method: 'post',
    data,
    load: true,
    debounce: true,
    }
  )
}

// 新增运动队
export function addGroup(data) {
  return request({
      url: '/sys/group/add',
      method: 'post',
      data,
      load: true,
    debounce: true,
    }
  )
}

// 删除运动队
export function deleteGroup(data) {
  return request({
      url: '/sys/group/del',
      method: 'post',
      data,
      load: true,
    debounce: true,
    }
  )
}

// 修改运动队
export function updateGroup(data) {
  return request({
      url: '/sys/group/edit',
      method: 'post',
      data,
      load: true,
    debounce: true,
    }
  )
}

// 获取运动队
export function getGroup(params) {
  return request({
      url: '/sys/group/getInfo',
      method: 'get',
      params,
      load: true
    }
  )
}

// 修改运动队状态
export function updateGroupStatus(data) {
  return request({
      url: '/sys/group/updateByStatus',
      method: 'post',
      data,
      load: true,
    debounce: true,
    }
  )
}

